export class CodeListMainId{
    codeListMainId : number;
}